import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from 'src/app/shared/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  constructor(private httpService: HttpService) {}

  getUserDetails(): Observable<any> {
    return this.httpService.get(`customer/GetUserDetails`);
  }
 
  getUserAddress(): Observable<any> {
    return this.httpService.get(`customer/GetUserAddress`);
  }

  getAllCompanies(): Observable<any> {
      return this.httpService.get(`company/GetAllCompanies`);
  }

  deleteCompany(deletingCompanyId: string, alternateCompanyId: string): Observable<any> {
    return this.httpService.delete(
      `company/DeleteCompany/${deletingCompanyId}?alternateCompanyId=${alternateCompanyId}`
    );
  }
}
